import axios from 'axios';

export default {
    async getContext(contenderId){
        const apiResponse = await axios.get(`/api/mediamanager/context/${contenderId}`);
        return apiResponse;
    },

    async postContenderMedia(contenderMedia){
        const apiResponse = await axios.post(`/api/mediamanager/media/${contenderMedia.contenderId}`, contenderMedia);
        return apiResponse;
    },

    async deleteContenderMedia(contenderId, contenderMediaId){
        const apiResponse = await axios.delete(`/api/mediamanager/media/${contenderId}?contenderMediaId=${contenderMediaId}`);
        return apiResponse;
    }
}